import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { observer } from 'mobx-react';
var useStyles = makeStyles()(function (theme) {
  return {
    contentBlock: {
      position: 'relative',
      minHeight: '100%',
      boxSizing: 'border-box',
      whiteSpace: 'nowrap',
      overflow: 'hidden'
    },
    elidedBlock: {
      minHeight: '100%',
      boxSizing: 'border-box',
      backgroundColor: '#999',
      backgroundImage: 'repeating-linear-gradient(90deg, transparent, transparent 1px, rgba(255,255,255,.5) 1px, rgba(255,255,255,.5) 3px)'
    },
    interRegionPaddingBlock: {
      minHeight: '100%',
      backgroundColor: theme.palette.text.disabled
    },
    boundaryPaddingBlock: {
      minHeight: '100%',
      backgroundColor: theme.palette.action.disabledBackground
    }
  };
});
var ContentBlock = observer(function (_ref) {
  var block = _ref.block,
    children = _ref.children;
  var _useStyles = useStyles(),
    classes = _useStyles.classes;
  var widthPx = block.widthPx;
  return React.createElement("div", {
    style: {
      width: widthPx
    },
    className: classes.contentBlock
  }, children);
});
function ElidedBlock(_ref2) {
  var width = _ref2.width;
  var _useStyles2 = useStyles(),
    classes = _useStyles2.classes;
  return React.createElement("div", {
    className: classes.elidedBlock,
    style: {
      width: width
    }
  });
}
function InterRegionPaddingBlock(_ref3) {
  var boundary = _ref3.boundary,
    width = _ref3.width,
    _ref3$style = _ref3.style,
    style = _ref3$style === void 0 ? {} : _ref3$style;
  var _useStyles3 = useStyles(),
    classes = _useStyles3.classes;
  return React.createElement("div", {
    style: _objectSpread({}, style, {
      width: width
    }),
    className: boundary ? classes.boundaryPaddingBlock : classes.interRegionPaddingBlock
  });
}
export { ContentBlock, ElidedBlock, InterRegionPaddingBlock };